import React from "react"
import PropTypes from "prop-types"
import COLOR_PALETTE from "constants/color-palette"
import Radium from "../../higher-order-components/configured-radium/"

const GlobalNavSearchResultsDrawer = ({ open, query, children }) => (
  <div style={{ position: "relative", zIndex: 5 }}>
    <div
      style={{
        position: "absolute",
        width: "100%",
        overflow: "hidden",
        pointerEvents: "none"
      }}>
      <div
        style={{
          backgroundColor: COLOR_PALETTE.GRAY_LIGHT,
          padding: "1.5em",
          pointerEvents: "all",
          boxSizing: "border-box",
          transition: `transform .5s ${open ? 0.5 : 0}s`,
          transform: open ? "none" : "translateY(-100%)"
        }}>
        {children}
      </div>
    </div>
  </div>
)

export default Radium(GlobalNavSearchResultsDrawer)

const styles = {}



// WEBPACK FOOTER //
// ./src/containers/global-nav-search/search-results-drawer.jsx